<template>
	<div class="search-hero__facet" v-if="in_config">
		<button type="button" @click="toggle" class="search-hero__facet-button" aria-haspopup="listbox" aria-expanded="true" aria-labelledby="listbox-label">
			<span class="block truncate" :title="smart_label">{{ smart_label }}</span>
			<span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
				<svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
					<path fill-rule="evenodd" d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z" clip-rule="evenodd" />
				</svg>
			</span>
		</button>

		<transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
			<ul v-if="show" class="search-hero__facet-options scrollable-blue" tabindex="-1" role="listbox" aria-labelledby="listbox-label" aria-activedescendant="listbox-option-3">
				<template v-for="(option,o) in options" :key="`facet_option_${o}`">
					<li class="text-gray-900 relative cursor-default select-none py-2 pl-3 pr-9" id="listbox-option-0" role="option">
						<label class="flex items-center">
							<input type="checkbox" :id="`${facetRef}_option_${o}`" :value="option.name" v-model="option.selected" @change="changeValue">
							<p>{{ option.name }}</p>
						</label>
						<span class="search-hero__facet-count">{{ option.count }}</span>
					</li>
				</template>
			</ul>
		</transition>
	</div>
</template>

<script>

import SearchMixin from '@/main/pages/search/mixins/SearchMixin';

export default {
	mixins: [SearchMixin],

	props: {
		facetRef: {
			type: String
		}
	},

	created() {
		this.emitter.on('hero:facets:close',this.close);
		this.emitter.on('update:search',this.close);
	},
	onBeforeUnmount() {
		this.emitter.off('hero:facets:close',this.close);
		this.emitter.off('update:search',this.close);
	},

	data() {
		return {
			show: false,
			options:[]
		}
	},
	methods: {
		toggle() {
			this.emitter.emit('hero:facets:close');
			this.show = !this.show;
		},
		close() {
			this.show = false;
		},
		changeValue() {
			this.show = false;
			this.search_params.global_facets[this.name] = this.selected_option_names;
			this.emitter.emit('update:search');
		},
		doClear() {
			this.show = false;
			this.search_params.global_facets[this.name] = [];
			this.emitter.emit('update:search');
		}
	},
	computed: {
		in_config() {
			return this.search_config.facets.find((facet) => {
				return facet.ref == this.facetRef;
			})
		},
		toggle_facets() {
			return this.search_config.facets.filter((facet) => {
				return facet.type == 'toggle' && facet.visible;
			})
		},
		accordian_facets() {
			return this.search_config.facets.filter((facet) => {
				return (facet.type == 'checkbox' || (facet.type == 'range' && this.search_config.use_salary_fields)) && facet.visible;
			})
		},
		facet() {
			return this.facet_info.find((facet) => {
				return facet.ref == this.facetRef;
			});
		},
		name() {
			return this.facet.name;
		},
		label() {
			return this.facet.label;
		},
		selected_options() {
			return this.options.filter((option) => {
				return option.selected;
			});
		},
		selected_option_names() {
			return this.selected_options.map((option) => {
				return option.name;
			});
		},
		smart_label() {
			if (this.selected_option_names.length > 0) {
				return this.selected_option_names.join(", ");
			}
			return this.label;
		}
	},
	watch: {
		facet_info: {
			deep: true,
			handler() {
				if (this.in_config) {
					console.log("Look for:",this.facetRef,"in",this.facet_info);
					this.options = this.facet_info.find((facet) => {
						return facet.ref == this.facetRef;
					}).options;
					this.$forceUpdate();
				}
			}
		}
	}
}
</script>
